'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSettingsRemote = function MdSettingsRemote(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 0c5.1 0 9.7 2 13 5.4l-2.4 2.3c-2.7-2.7-6.5-4.3-10.6-4.3s-7.9 1.6-10.6 4.3l-2.4-2.3c3.3-3.3 7.9-5.4 13-5.4z m-8.3 10.1c2.1-2.1 5.1-3.5 8.3-3.5s6.2 1.4 8.3 3.5l-2.4 2.3c-1.4-1.5-3.6-2.4-5.9-2.4s-4.5 0.9-5.9 2.4z m8.3 14.9c1.8 0 3.4-1.6 3.4-3.4s-1.6-3.2-3.4-3.2-3.4 1.4-3.4 3.2 1.6 3.4 3.4 3.4z m5-10c0.9 0 1.6 0.7 1.6 1.6v20c0 1-0.7 1.8-1.6 1.8h-10c-0.9 0-1.6-0.8-1.6-1.8v-20c0-0.9 0.7-1.6 1.6-1.6h10z' })
        )
    );
};

exports.default = MdSettingsRemote;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/settings-remote.js
// module id = 3524
// module chunks = 0